<template>
  <v-container pa-0 fluid @touchstart="touchEnable">
    <v-layout row wrap>

      <v-flex xs12>
        <div class="banner">
          <span style="font-weight: 300;">혼자하는 고민은 이제 그만!</span>
          <br>
          <span>묻고, 답하고, 공유하세요
            <v-icon color="white">$vuetify.icons.commentFilled</v-icon>
          </span>
        </div>
      </v-flex>

      <div class="writing-bar">
        <v-avatar size="32px" class="mx-3">
          <v-img :src="profileImageSrc"></v-img>
        </v-avatar>

        <v-btn class="border-radius-custom ma-0"
               flat
               block
               color="#cdcdcd"
               @click="$router.push({ name: 'WriteForm' })">
          <v-layout justify-space-between>
            <span>글 작성하기</span>
            <v-icon>$vuetify.icons.write</v-icon>
          </v-layout>
        </v-btn>

        <v-icon style="width: 32px; height: 32px;"
                @click="sheet = true"
                :color="menuIdx.length || nationIdx.length ? '#4a4a4a' : 'rgba(74,74,74,0.3)'"
                class="mx-3">$vuetify.icons.filter</v-icon>
      </div>

      <v-flex xs12>
        <PostListCard v-for="post of community" :key="post.idx"
                      :type="post.type"
                      :postIdx="post.idx"
                      :createdAt="post.created_at"
                      :updatedAt="post.updated_at"
                      :menuIdx="post.menu_idx"
                      :menuName="post.menus ? post.menus.name : null"
                      :nationIdx="post.nation_idx"
                      :nationName="post.nations ? post.nations.name : null"
                      :title="post.title"
                      :contents="post.contents"
                      :thumbnail="post.thumbnail"
                      :imageList="post.image_list"
                      :bookmarks="post.bookmarks"
                      :user="post.user"
                      :viewCnt="post.view_cnt"
                      :likeCnt="post.like_cnt"
                      :likes="post.likes"
                      :commentCnt="post.comment_cnt"
                      @like="likePost(post.idx)"
                      @bookmark="bookmarkPost(post.idx)"
        />
      </v-flex>

    </v-layout>

    <v-bottom-sheet v-model="sheet">
      <v-card class="bottom-sheet-custom">
        <div class="bottom-sheet-custom-holder">
          <div class="bottom-sheet-custom-gradient-holder"></div>

          <div class="filter-swiper-container swiper-container" style="width: 100%;">
            <div class="filter-swiper-wrapper swiper-wrapper">
              <div class="filter-swiper-slide swiper-slide">
                <v-list class="pa-0">
                  <v-list-tile v-for="menu of communityMenu" :key="menu.code"
                               class="nation-list-tile"
                               @click="changeFilter(menu.idx)">
                    <span>{{ menu.name }}</span>
                    <v-icon color="#ec2f54" size="24px" v-if="menuIdx.includes(menu.idx)">$vuetify.icons.confirm</v-icon>
                  </v-list-tile>
                </v-list>
              </div>

              <div class="filter-swiper-slide swiper-slide">
                <v-list class="pa-0">
                  <v-list-tile v-for="nation of communityNations" :key="nation.code"
                               class="nation-list-tile"
                               @click="changeFilter(undefined, nation.idx)">
                    <span>{{ nation.name }}</span>
                    <v-icon color="#ec2f54" size="24px" v-if="nationIdx.includes(nation.idx)">$vuetify.icons.confirm</v-icon>
                  </v-list-tile>
                </v-list>
              </div>
            </div>
          </div>

          <div class="filter-swiper-pagination swiper-pagination"
							 :style="{ right: $vuetify.breakpoint.width <= 950 ? '24px' : 'calc((100vw - 950px) / 2 + 24px)' }"></div>

        </div>
      </v-card>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';

  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import PostListCard from "@/components/PostListCard";

  export default {
    name: 'Community',
    components: { PostListCard },
    props: [ 'isActive' ],
    computed: {
      ...mapGetters(['communityNations', 'communityMenu']),
      ...mapGetters('home', [ 'community', 'communityMaxPage' ]),
      ...mapGetters('user', [ 'profile_image' ]),
      profileImageSrc () {
        return this.profile_image ? `${this.$storage}/user/profile/${this.profile_image}` : require('@/assets/img/profile-default.png');
      }
    },
    data () {
      return {
        second: parseInt(new Date().getTime() / 1000),
        page: 1,
        sheet: false,
        filterSwiper: null,
        menuIdx: [],
        oldMenuIdx: [],
        nationIdx: [],
        oldNationIdx: [],
        bottom: true,
      };
    },
    created () {
      if (!this.communityMenu.length) this.selectCommunityFilters();
      this.selectCommunity({
        page: this.page,
        second: this.second,
      }).then(() => {
        this.page++;
      });
      window.addEventListener('scroll', this.bottomVisible);
    },
    destroyed () {
      window.removeEventListener('scroll', this.bottomVisible);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (this.isActive && bottom && !oldBottom) {
          this.selectCommunity({
            second: this.second,
            page: this.page,
            menuIdx: this.menuIdx.length ? this.menuIdx.join(',') : undefined,
            nationIdx: this.nationIdx.length ? this.nationIdx.join(',') : undefined,
          }).then(() => {
            this.page++;
          });
        }
      },
      sheet (isOpen) {
        if (isOpen) {
          this.oldMenuIdx = [];
          this.oldNationIdx = [];
          this.menuIdx.forEach(idx => {
            this.oldMenuIdx.push(idx);
          });
          this.nationIdx.forEach(idx => {
            this.oldNationIdx.push(idx);
          });
          this.$nextTick(() => {
            if (!this.filterSwiper) {
              this.filterSwiper = new Swiper('.filter-swiper-container', {
                direction: 'horizontal',
                slidesPerView: 1,
                pagination: {
                  el: '.filter-swiper-pagination'
                },
                // navigation: {
                //   nextEl: '.youth-icon-arrow-stick-right',
                //   prevEl: '.youth-icon-arrow-stick-left',
                // },
              });
            } else {
              this.filterSwiper.update();
            }
          });
        } else {
          if (this.menuIdx.join(',') !== this.oldMenuIdx.join(',') || this.nationIdx.join(',') !== this.oldNationIdx.join(',')) {
            this.page = 1;
            this.second = parseInt(new Date().getTime() / 1000);
            this.selectCommunity({
              page: this.page,
              second: this.second,
              menuIdx: this.menuIdx.length ? this.menuIdx.join(',') : undefined,
              nationIdx: this.nationIdx.length ? this.nationIdx.join(',') : undefined,
            }).then(() => {
              this.page++;
            });
          }
        }
      }
    },
    methods: {
      ...mapActions([ 'selectCommunityFilters' ]),
      ...mapActions('home', [ 'selectCommunity' ]),
      ...mapActions('post', [ 'toggleLike', 'toggleBookmark' ]),
      ...mapMutations('home', { mutationToggleLike: 'TOGGLE_LIKE', mutationToggleBookmark: 'TOGGLE_BOOKMARK' }),
      touchEnable () {
        this.$eventBus.$emit('touchCancel', false);
      },
      likePost (postIdx) {
        this.toggleLike(postIdx).then(response => {
          this.mutationToggleLike({ idx: postIdx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      bookmarkPost (postIdx) {
        this.toggleBookmark(postIdx).then(response => {
          this.mutationToggleBookmark({ idx: postIdx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      changeFilter (menuIdx, nationIdx) {
        if (typeof menuIdx !== 'undefined') {
          this.menuIdx.includes(menuIdx) ? this.menuIdx.splice(this.menuIdx.indexOf(menuIdx), 1) : this.menuIdx.push(menuIdx);
          this.menuIdx.sort((a, b) => a - b);
        }
        if (typeof nationIdx !== 'undefined') {
          this.nationIdx.includes(nationIdx) ? this.nationIdx.splice(this.nationIdx.indexOf(nationIdx), 1) : this.nationIdx.push(nationIdx);
          this.nationIdx.sort((a, b) => a - b);
        }
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 300;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .banner {
    padding: 28px 0;
    color: white;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.5px;
    background-image: linear-gradient(to right, #4a4a4a, #1a1a1a);
  }

  .writing-bar {
    width: 100vw;
    display: flex;
    background-color: white;
    padding: 16px 0;
    align-items: center;
    border-bottom: 1px solid #eaeaea;

    margin-bottom: -8px;

    /*position: sticky;*/
    /*top: 48px;*/
    /*z-index: 2;*/
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    height: 40px;
    background-color: #f4f4f4;
    border: 1px solid #eaeaea;
    font-size: 16px;
    letter-spacing: -0.6px;
    font-weight: 300;
    /*.v-input__slot {*/
    /*  cursor: pointer !important;*/
    /*  padding: 0 18px !important;*/
    /*}*/
    /*input {*/
    /*  cursor: pointer !important;*/
    /*}*/
  }

  .bottom-sheet-custom {
    height: calc(100vh - 260px);
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    padding-top: 27px;
    &-holder {
      position: relative;
      padding-bottom: 168px;
      height: 100%;
      overflow-y: scroll;
      border-radius: 0 !important;
    }
    &-gradient-holder {
      position: fixed;
      bottom: 0;
      width: 100vw;
			max-width: 950px;
      height: 168px;
      z-index: 2;
      pointer-events: none;
      background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1));
    }
  }
  /deep/.nation-list-tile .v-list__tile {
    height: 56px;
    padding: 0 32px;

    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.36px;
    font-weight: 700;

    display: flex;
    justify-content: space-between;
  }
  /deep/.filter-swiper-pagination {
    position: fixed;
    bottom: 32px;
    z-index: 3;
    .swiper-pagination-bullet + .swiper-pagination-bullet {
      margin-left: 8px;
    }
    .swiper-pagination-bullet-active {
      background: #ec2f54;
    }
  }
</style>
